module.exports = __webpack_public_path__ + "assets/img/zyrw03.ce788cf7.png";